// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserDashboard/UserDashboard.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;CACnB,sBAAsB;AACvB","sourcesContent":[".dashboard-container {\n\tdisplay: flex;\n\tjustify-content: space-evenly;\n\talign-items: center;\n\tflex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
